import { AccountType } from "store/auth/types";

export const ACCOUNTS = [
  { key: AccountType.user, value: "User Account" },
  { key: AccountType.business, value: "Business Account" },
];
